module.exports = __webpack_public_path__ + "static/media/BaseBall.8f8568cd.svg";